import React from "react";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core";
import Fingerprint from "@material-ui/icons/Fingerprint";
import isAdmin from "../../../utils/isAdmin";
import isSafeAdmin from "../../../utils/isSafeAdmin";

const useStyles = makeStyles({
  chip: {
    position: "absolute",
    bottom: 0,
    right: 0,
    backgroundColor: (props) => props.backgroundColor,
    fontSize: ".6rem",
    fontWeight: 700,
    color: (props) => props.color,
    "& .MuiChip-label": {
      marginTop: "4px",
    },
  },
});

const AlbumRestrictions = ({ contentId }) => {
  const canView = isAdmin() || isSafeAdmin();

  // if not admin, hide
  if (!canView) return null;

  // only show if contentId exists
  if (!contentId) return null;

  // color
  let backgroundColor = "transparent";
  let color = "white";

  if (contentId === "ineligible") {
    backgroundColor = "gold";
    color = "#646464";
  }

  const classes = useStyles({ backgroundColor, color });

  return <Chip label={<Fingerprint />} className={classes.chip} size="small" />;
};

export default AlbumRestrictions;
